






import { defineComponent } from '@vue/composition-api';
import { Icon } from '@iconify/vue2';

export default defineComponent({
    name: 'NotificationAdministratorIcon',
    components: {
        Icon,
    },
    props: {
        dropdown: {
            type: Boolean,
            default: false,
        },
    },
});
